export const DOWNLOAD_ERRORS = {
  generic: 'An error occurred during the download.',
  failed: 'Download failed. Please try again later.',
};
